import { get } from "../../service/api";

const CheckUserHasPin = async (userId) => {
    try {
        const response = await get(`/user/${userId}/hasPin`);
        return response;
    } catch (error) {
        console.error('Error CheckUserHasPin:', error);
        throw error;
    }
};

export default CheckUserHasPin;